/**
 * Intarsia Mini Cart - Delete Buttons
 * Fixed version - no infinite loops
 */

(function() {
  'use strict';
  
  let isEnhancing = false; // Prevent re-entry
  
  function addDeleteButtons() {
    // Prevent concurrent runs
    if (isEnhancing) return;
    isEnhancing = true;
    
    try {
      // Target the actual minicart structure from your theme
      const cartItems = document.querySelectorAll('.minicart_item');
      
      if (cartItems.length === 0) {
        isEnhancing = false;
        return;
      }
      
      cartItems.forEach((item, index) => {
        // Skip if already has our delete button
        if (item.querySelector('.intarsia-delete-btn')) {
          return;
        }
        
        // Find the existing remove button/link to get the line number
        const existingRemove = item.querySelector('.remove-product');
        const lineNumber = existingRemove ? existingRemove.getAttribute('data-line') : (index + 1);
        
        // Find the li element that contains the cart item content
        const listItem = item.querySelector('li.d-flex');
        if (!listItem) {
          isEnhancing = false;
          return;
        }
        
        // Create delete button
        const deleteBtn = document.createElement('button');
        deleteBtn.className = 'intarsia-delete-btn';
        deleteBtn.innerHTML = '×';
        deleteBtn.setAttribute('aria-label', 'Remove item from cart');
        deleteBtn.setAttribute('type', 'button');
        deleteBtn.setAttribute('data-line', lineNumber);
        
        // Inline styles for visibility
        deleteBtn.style.cssText = `
          position: absolute;
          top: 5px;
          right: 5px;
          width: 28px;
          height: 28px;
          border: 1px solid #542933;
          background: white;
          color: #542933;
          border-radius: 50%;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 100;
          padding: 0;
          font-weight: 300;
          transition: all 0.2s ease;
        `;
        
        // Hover effects
        deleteBtn.addEventListener('mouseenter', function() {
          this.style.background = '#542933';
          this.style.color = 'white';
        });
        
        deleteBtn.addEventListener('mouseleave', function() {
          this.style.background = 'white';
          this.style.color = '#542933';
        });
        
        // Click handler
        deleteBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          removeCartItem(this.getAttribute('data-line'), item);
        });
        
        // Ensure parent is positioned
        listItem.style.position = 'relative';
        
        // Add button to the list item
        listItem.appendChild(deleteBtn);
      });
      
    } finally {
      isEnhancing = false;
    }
  }
  
  function removeCartItem(line, itemElement) {
    // Show loading state
    itemElement.style.opacity = '0.5';
    itemElement.style.pointerEvents = 'none';
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: parseInt(line),
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Animate out
      itemElement.style.transition = 'all 0.3s ease';
      itemElement.style.transform = 'translateX(100%)';
      itemElement.style.opacity = '0';
      itemElement.style.maxHeight = itemElement.offsetHeight + 'px';
      
      setTimeout(() => {
        itemElement.style.maxHeight = '0';
        itemElement.style.padding = '0';
        itemElement.style.margin = '0';
        itemElement.style.overflow = 'hidden';
      }, 200);
      
      setTimeout(() => {
        itemElement.remove();
        updateCartDisplay(cart);
        
        // Re-run to fix line numbers after removal
        setTimeout(addDeleteButtons, 100);
      }, 400);
    })
    .catch(error => {
      console.error('Error removing item:', error);
      itemElement.style.opacity = '1';
      itemElement.style.pointerEvents = 'auto';
      alert('Unable to remove item. Please try again.');
    });
  }
  
  function updateCartDisplay(cart) {
    // Update cart count
    const countElements = document.querySelectorAll('.enj-cartcount, .cart-counter, .cart-count, .mini-cart-counter span');
    countElements.forEach(el => {
      el.textContent = cart.item_count;
    });
    
    // Update cart total - find all possible total elements
    const totalElements = document.querySelectorAll('.total-price, .enj-cartcost, .mini-cart-total-price');
    totalElements.forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });
    
    // If cart is empty, reload to show empty state
    if (cart.item_count === 0) {
      location.reload();
    }
  }
  
  function formatMoney(cents) {
    // Handle edge cases
    if (cents === null || cents === undefined || isNaN(cents)) {
      return '$0.00 USD';
    }
    
    // Shopify returns cents as integer
    const dollars = (parseInt(cents, 10) / 100).toFixed(2);
    
    // Add comma separators for thousands
    const parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    return '$' + parts.join('.') + ' USD';
  }
  
  // Initialize once on page load
  function init() {
    addDeleteButtons();
    
    // Watch for cart drawer opening (more targeted observer)
    const minicart = document.querySelector('.js-minicart');
    if (minicart) {
      const observer = new MutationObserver(function(mutations) {
        // Only run if class changed (cart opened/closed)
        const classChanged = mutations.some(m => m.attributeName === 'class');
        if (classChanged && minicart.classList.contains('active')) {
          setTimeout(addDeleteButtons, 200);
        }
      });
      
      observer.observe(minicart, { 
        attributes: true, 
        attributeFilter: ['class'] 
      });
    }
    
    // Listen for AJAX cart updates from theme
    document.addEventListener('ajaxCart.afterCartLoad', function() {
      setTimeout(addDeleteButtons, 200);
    });
    
    // Also listen for custom cart update events
    document.addEventListener('cart:updated', function() {
      setTimeout(addDeleteButtons, 200);
    });
    
    // Fallback: run when clicking cart icon
    const cartTriggers = document.querySelectorAll('[href="/cart"], .cart-icon, .header-cart, .js-open-minicart');
    cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        setTimeout(addDeleteButtons, 300);
      });
    });
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
